import SocketIOClient from 'socket.io-client';
import { HOST } from '../configs/index'
import { SUPERADMIN } from '../constant/TypeRole';

class Socket {
    constructor() {
        this.socket = SocketIOClient(HOST, {
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
            reconnectionAttempts: Infinity,
        });
        this.connect()
        this.reconnect()
    }

    onReceiveMessage = (onReceiveSocketEvent) => this.socket.on('message', onReceiveSocketEvent);
    reconnect = () => this.socket.on('reconnect', () => this.connect())
    disconnect = () => this.socket.disconnect()
    connect = () => {
        const project = JSON.parse(localStorage.getItem('project'))
        const role = localStorage.getItem('role')
        if (role === SUPERADMIN) {
            this.socket.emit('subscribe', 'admin_all');
        } else {
            for (const p in project) {
                this.socket.emit('subscribe', `admin_${project[p]}`);
            }
        }
    }
}

// const connect = (onReceiveSocketEvent) => {
//     const project = JSON.parse(localStorage.getItem('project'))
//     const role = localStorage.getItem('role')
//     if (project) {
//         const socket = SocketIOClient(HOST, {
//             reconnection: true,
//             reconnectionDelay: 1000,
//             reconnectionDelayMax: 5000,
//             reconnectionAttempts: Infinity,
//         });
//         if (role === SUPERADMIN) {
//             socket.emit('subscribe', 'admin_all');
//         } else {
//             for (const p in project) {
//                 socket.emit('subscribe', `admin_${p}`);
//             }
//         }
//         socket.on('message', onReceiveSocketEvent);
//         socket.on('reconnect', (reason) => {
//             if (role === SUPERADMIN) {
//                 socket.emit('subscribe', 'admin_all');
//             } else {
//                 for (const p in project) {
//                     socket.emit('subscribe', `admin_${p}`);
//                 }
//             }
//         });
//     }
// };

export default Socket;




// WEBPACK FOOTER //
// ./src/services/socketIO.js